export default "__VITE_ASSET__DReZgLCc__"